// @internal
import React, { useContext } from 'react';
import { Icon } from '../../../Icon/Icon';
import { SideNavContext } from '../../SideNavContext';
import getGlobalProps from '../../../../helpers/constants/global-props';
import { StyledSideNavTwiddle } from './styles';

export interface SideNavTwiddleProps extends React.HTMLAttributes<HTMLSpanElement> {
  open?: boolean;
  'data-testid'?: string | number;
}

const SideNavTwiddle = (props: SideNavTwiddleProps) => {
  const { open, ...otherProps } = props;
  const { isClosed } = useContext(SideNavContext);
  const globalProps = getGlobalProps({});
  return (
    <StyledSideNavTwiddle open={open} isVisible={!isClosed} {...otherProps} {...globalProps}>
      <Icon type="forward" size="xs" aria-hidden="true" />
    </StyledSideNavTwiddle>
  );
};

SideNavTwiddle.displayName = 'SideNav.Twiddle';

export default SideNavTwiddle;
